//@flow

export type InformationField = {
  label: string,
  value: string,
};

export const INFORMATION_FIELDS_BY_COUNTRY: {
  [countryCode: string]: InformationField[],
} = Object.freeze({
  PE: [
    {label: 'Razón social', value: ''},
    {label: 'RUC', value: ''},
    {label: 'Dirección', value: ''},
  ],
});

// Country ISO codes that always use the internal claim module (FORM) and hide the external link.
// Add a code here to enable for a new country (e.g. 'CL').
export const INTERNAL_COMPLAINT_MODULE_COUNTRY_CODES = Object.freeze(['PE']);

export function usesInternalComplaintModule(countryCode: ?string): boolean {
  if (!countryCode) return false;
  return INTERNAL_COMPLAINT_MODULE_COUNTRY_CODES.includes(countryCode);
}

export function getDefaultInformationFields(
  countryCode: ?string
): InformationField[] {
  if (!countryCode) return [];
  return INFORMATION_FIELDS_BY_COUNTRY[countryCode] || [];
}
